import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

export const useNavigationStore = create(
    devtools(
        (set, get) => ({
            expoTitle: null,
            pages: [],
            pageGroups: [],
            mymLinks: [],
            report: null,
            isReady: false,

            setExpoTitle: (expoTitle) => set({ expoTitle }),
            setPages: (pages) => set({ pages, isReady: true }),
            setPageGroups: (pageGroups) => set({ pageGroups, isReady: true }),
            setMymLinks: (mymLinks) => set({ mymLinks }),
            setReport: (report) => set({ report }),
            setNavigationData: (data) =>
                set((state) => ({
                    ...state,
                    ...data,
                    isReady: true,
                })),
            getMenuPages: () => get().pages.filter((page) => page.menu === 'yes'),
        }),
        { name: 'NavigationStore' }
    )
);
